module.exports = __webpack_public_path__ + "img/service3.dc7a409a.svg";